import {get, post, put,Delete} from '../axios'


// 注册协议-修改
export const registerUpdate = params => put('/web/system/register/update',params);

// 注册协议-查看
export const registerView = params => get(`/web/system/register/view`);